import React from "react"
import NavBar from "../components/navbar";

export default function Account(){
    return(
        <div>
            <NavBar/>
            <h1>Account</h1>
        </div>
    );
}